import React, { useRef, useState } from "react";
import { ColorPicker } from "@/components/vault/filter-controller/ColorPicker";
import { useClickOutside } from "@/hooks/useClickOutside";

export type ColourControllerProps = {
  label: string;
  value: string;
  setValue: (value: string) => void;
};

export const ColourController = ({
  value,
  setValue,
}: ColourControllerProps) => {
  const colorPickerRef = useRef<HTMLDivElement>(null);

  const [openColorPicker, setOpenColorPicker] = useState(false);

  useClickOutside(colorPickerRef, () => {
    if (openColorPicker) {
      setOpenColorPicker(false);
    }
  });

  return (
    <div ref={colorPickerRef} className="flex justify-end items-start">
      <div
        className="w-6 h-6 rounded-[8px] flex-shrink-0 cursor-pointer border border-solid border-[var(--border-tertiary)]"
        style={{
          backgroundColor: value,
        }}
        onClick={() => setOpenColorPicker((current) => !current)}
      />
      {openColorPicker && (
        <div className="absolute mt-8 w-[200px] z-10 p-2 bg-[var(--white)] rounded-lg shadow-[0_0_4px_0_rgba(0,0,0,0.05)]">
          <ColorPicker value={value} onChange={setValue} />
          {/*<div className="flex w-full items-center gap-2">*/}
          {/*  <div className="w-14 pl-2">*/}
          {/*    <HUI.Text*/}
          {/*      kind={HENGE.TEXT_KIND.small}*/}
          {/*      weight={HENGE.TEXT_WEIGHT.medium}*/}
          {/*      colour={HENGE.SEMANTIC_TEXT_COLOUR["text-tertiary"]}*/}
          {/*      whiteSpace={HENGE.TEXT_WHITE_SPACE.nowrap}*/}
          {/*    >*/}
          {/*      Hex*/}
          {/*    </HUI.Text>*/}
          {/*  </div>*/}
          {/*  <HUI.Input*/}
          {/*    kind={HENGE.INPUT_KIND.filled}*/}
          {/*    size={HENGE.DETAILED_SIZE.small}*/}
          {/*    fullWidth*/}
          {/*    textStyleProps={{*/}
          {/*      weight: HENGE.TEXT_WEIGHT.medium,*/}
          {/*      kind: HENGE.TEXT_KIND.small,*/}
          {/*      colour: HENGE.SEMANTIC_TEXT_COLOUR["text-secondary"],*/}
          {/*    }}*/}
          {/*    value={value}*/}
          {/*    setValue={setValue}*/}
          {/*  />*/}
          {/*</div>*/}
        </div>
      )}
    </div>
  );
};
